/* Grid / list / rows switcher for record listing pages.
   Applies a modifier class to every .record-grid on the page and remembers
   the choice in localStorage. Re-applies after facets.js re-renders the
   collection results via AJAX (see the "wiley:collection-rendered" event). */
(function () {
  'use strict';

  var STORAGE_KEY = 'wileyViewMode';
  var MODES = ['grid', 'list', 'compact'];

  function readStoredMode() {
    try {
      var stored = localStorage.getItem(STORAGE_KEY);
      return MODES.indexOf(stored) !== -1 ? stored : 'grid';
    } catch (e) {
      return 'grid';
    }
  }

  function storeMode(mode) {
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch (e) {
      /* private browsing / storage disabled — mode just won't persist */
    }
  }

  function applyMode(mode) {
    document.querySelectorAll('.record-grid').forEach(function (grid) {
      MODES.forEach(function (m) {
        grid.classList.remove('record-grid--' + m);
      });
      if (mode !== 'grid') grid.classList.add('record-grid--' + mode);
    });
    document.querySelectorAll('[data-view-toggle] button').forEach(function (btn) {
      btn.setAttribute('aria-pressed', String(btn.getAttribute('data-view') === mode));
    });
  }

  function bind() {
    document.querySelectorAll('[data-view-toggle] button').forEach(function (btn) {
      if (btn.dataset.viewBound) return;
      btn.dataset.viewBound = '1';
      btn.addEventListener('click', function () {
        var mode = btn.getAttribute('data-view');
        storeMode(mode);
        applyMode(mode);
      });
    });
  }

  function init() {
    applyMode(readStoredMode());
    bind();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('wiley:collection-rendered', init);
})();
